
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { JwtHelperService } from '@auth0/angular-jwt';

import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
let httpHeaders = new HttpHeaders()

  .set('Content-Type', 'application/json');
let options = {
  headers: httpHeaders
};
@Injectable({
  providedIn: 'root',
})


export class AuthService {
  baseUrl = environment.apiUrl+'Auth/';
  jwtHelper = new JwtHelperService();
  decodedToken: any;


  constructor(private http: HttpClient) {}

  login(model: any) {
    return this.http.post(this.baseUrl + 'login', model).pipe(
      map((response: any) => {
        const user = response;
        if (user) {
          localStorage.setItem('token', user.token);
          this.decodedToken=this.jwtHelper.decodeToken(user.token);
        
        }
      })
    );
  }

  LoggendIn() {
    const token = localStorage.getItem('token');
    return !this.jwtHelper.isTokenExpired(token);
  }

  CheckMac(): Observable<HttpResponse<any>> {
    return this.http.get<HttpResponse<any>>(this.baseUrl + 'MacRestrict', {
      observe: 'response'
    });
  }

}
